const namespaced=true;
import {loginByAccount,register,sendZC} from "@/api/login";
const state={
    token:''
}
const mutations={
    // setToken(state,token){
    //     state.token=token
    // }
}
const actions={
    // 登录
    async login({ commit }, params) {
        let {passWord,userName}=params
        const res = await loginByAccount({passWord,userName})
       let {code,data}=res
        if(code==200){
            window.localStorage.setItem('Authorization',data.token)
        }else {
            return Promise.reject(new Error('fail'))
        }
    },
    // 注册
    async register({ commit }, params) {
        const res = await register(params)
    },
    // 发送验证码
    async sendZC({ commit }, params) {
        let {userName}=params
        const res = await sendZC({userName:userName})
    },
}

const getters={

}
export default {
    mutations,
    actions,
    state,
    namespaced,
    getters
}
